import logo from "../../public/images/logo.png";
import new_logo from "../../public/images/new_logo.png";

export const flashPCBLogo = logo;
export const newFlashPCBLogo = new_logo;
